(() => {
  const initSection = (section) => {
    if (!section.classList.contains("js-sc-animate")) return;

    const targets = section.querySelectorAll(".js-sc-target");
    if (!targets.length) return;

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-inview");
          currentObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: "0px 0px -8% 0px" },
    );

    targets.forEach((target) => observer.observe(target));
  };

  document.querySelectorAll("[data-simple-composition]").forEach(initSection);

  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target.querySelector("[data-simple-composition]");
    if (section) initSection(section);
  });
})();
